export default "__VITE_ASSET__DYTgkM$c__"